import React from 'react';

interface AutosaveIndicatorProps {
  isSaving: boolean;
  isEdited: boolean;
}

export const AutosaveIndicator: React.FC<AutosaveIndicatorProps> = ({ isSaving, isEdited }) => {
  if (!isEdited) return null;

  return isSaving ? (
    <span className="text-sm text-indigo-600 mr-2">Autosaving...</span>
  ) : (
    <span className="text-sm text-green-600 mr-2">Changes autosaved</span>
  );
};
